import http from "../../../utils/services/http-client";
import urlHelper from "../../../utils/urlHelper/UrlHelper";
import {BorrowRequestModel, ProductListFilterModel} from "../models";

class ProductService {
  getProductList(model:ProductListFilterModel) {
    const queryParams = urlHelper(model);
    return http.get(`/Products?${queryParams}`);
  }
  getUserProductList() {
    return http.get(`/UserProducts`);
  }
  getCalculateProductPrice(model:any) {
    const queryParams = urlHelper(model);
    return http.get(`/CalculateProductPrice?${queryParams}`);
  }
  getProductDetail(id:string) {
    return http.get(`/Product?id=${id}`);
  }
  registerBookMark(id:string) {
    return http.post(`/Bookmarks`,id);
  }
  registerBorrowRequest(model:BorrowRequestModel) {
    return http.post(`/BorrowRequest/SendBorrowRequest`,model);
  }
  deleteProduct(productId :string) {
    return http.delete(`/`+productId);
  }

}

export default new ProductService();
